export interface HelpSection {
    title: string;
    content: string[];
}

export interface HelpContent {
    overview: string;
    sections: HelpSection[];
}

export const siteAccessPoliciesHelp = {
    "/share/business/site-access-policies": {
        overview: "Site Access Policies allow you to create rules and instructions for drivers accessing your charging locations.",
        sections: [
            {
                title: "Managing Policies",
                content: [
                    "View all your existing site access policies in this list",
                    "Click on any policy to edit its details",
                    "Create new policies to manage different locations or requirements"
                ]
            },
            {
                title: "Policy Types",
                content: [
                    "Global Policies: Apply to all your charging locations",
                    "Location-Specific Policies: Apply only to selected locations"
                ]
            },
            {
                title: "Best Practices",
                content: [
                    "Use descriptive names for easy identification",
                    "Create specific policies for different types of locations",
                    "Regularly review and update your policies"
                ]
            }
        ]
    },

    "/share/business/site-access-policies/edit": {
        overview: "Creating/Editing Site Access Policy",
        sections: [
            {
                title: "Policy Details",
                content: [
                    "Enter a unique name for your site access policy",
                    "This name will be used to identify the policy in your dashboard"
                ]
            },
            {
                title: "Locations (if applicable)",
                content: [
                    "Select All: Click to add all available locations to the policy",
                    "Clear All: Click to remove all selected locations from the policy",
                    "Individual Selection: Click on any location name to add it to the policy",
                    "Remove Locations: Click the X on any selected location chip to remove it",
                    "View Selected: Selected locations appear as chips above the list"
                ]
            },
            {
                title: "Driver Instructions",
                content: [
                    "Add Instructions: Click 'Add Instruction' to create new driver instructions",
                    "Edit Instructions: Click directly on any instruction text to edit it",
                    "Multiple Instructions: Add as many instructions as needed for drivers"
                ]
            },
            {
                title: "Save Your Policy",
                content: [
                    "Click 'Save Policy' to save all your changes",
                    "The system will validate your inputs and show success/error messages",
                    "You can return to edit the policy later from the policies list"
                ]
            },
            {
                title: "Tips",
                content: [
                    "Make sure to give your policy a descriptive name",
                    "Add clear, specific instructions for drivers",
                    "Select only the locations where this policy should apply",
                    "Test your policy by viewing it from a driver's perspective"
                ]
            }
        ]
    }
}; 